const tplData = {
    "name": "清浅明亮型",
    "key": "clear_light",
    "svg": [
        {
            "path": "M58.0518 0H188.052V406L58.0518 0Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M318.051 0H188.051V406L318.051 0Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M318.051 812H188.051V406L318.051 812Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M58.0518 812H188.052V406L58.0518 812Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M318.052 0H375.052V148L188.052 406L318.052 0Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M318.052 812H375.052V664L188.052 406L318.052 812Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M58.0518 812H0.0517578V664L188.052 406L58.0518 812Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M58.0518 0H0.0517578V148L188.052 406L58.0518 0Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M375.052 270V148L188.052 406L375.052 270Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M0.0517578 270V148L188.052 406L0.0517578 270Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M375.052 542V664L188.052 406L375.052 542Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M0.0517578 542V664L188.052 406L0.0517578 542Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M375.052 345V270L188.052 406L375.052 345Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M0.0517578 345V270L188.052 406L0.0517578 345Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M375.052 467V542L188.052 406L375.052 467Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M0.0517578 467V542L188.052 406L0.0517578 467Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M375.052 406V345L188.052 406H375.052Z",
            "color": "#FFFFFF"
        },
        {
            "path": "M0.000595093 406V345L188.052 406H0.000595093Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M375.052 406V467L188.052 406H375.052Z",
            "color": "#F2F2F2"
        },
        {
            "path": "M0.0517578 406V467L188.052 406H0.0517578Z",
            "color": "#FFFFFF"
        }
    ]
};

export default function () {
    let tpl = JSON.parse(JSON.stringify(tplData));

    tpl.name  = ''
    tpl.key = 'c' + Math.floor(new Date().getTime() / 1000);

    return tpl
}